import { createSlice } from '@reduxjs/toolkit'

export const CampaignFlagSlice = createSlice({
  name: 'campaignFlag',
  initialState: {
    value: {},
  },
  reducers: {
    setCampaignFlag: (state, action) => {
        if(action.payload.type){
            return { ...state,
                value:{
                  ...state.value,[action.payload.type]: action.payload.value
                }              
            }
        }
        else{
          state.value = action.payload
        }
    },
  },
})

export const { setCampaignFlag } = CampaignFlagSlice.actions

export default CampaignFlagSlice.reducer